export default {
  signatories: state => state.signatories,
  searchParams: state => state.searchParams,
  pagination: state => state.pagination,
};



// WEBPACK FOOTER //
// ./src/store/modules/signatory/getters.js